import React from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../../components/ui/alert-dialog";

export default function DeleteConfirmDialog({ trade, onCancel, onConfirm }) {
  return (
    <AlertDialog open={!!trade} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent className="bg-[#121318] border-[#27272A] text-white rounded-sm" data-testid="delete-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white">Delete this trade?</AlertDialogTitle>
          <AlertDialogDescription className="text-[#A1A1AA]">
            {trade?.stock} · {trade?.quantity} @ {trade?.rate}. This cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-transparent border-[#27272A] text-[#A1A1AA] hover:bg-[#1A1B23] hover:text-white rounded-sm">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="confirm-delete" onClick={onConfirm} className="bg-[#FF3B30] hover:bg-[#FF3B30]/90 text-white rounded-sm">Delete</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
